var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98438 9.66626H20.0258",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6409 3V5.96174",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36841 3V5.96174",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8145 4.42188H8.19413C5.55056 4.42188 3.90039 5.89399 3.90039 8.59984V16.7456C3.90039 19.4943 5.55056 21.0004 8.19413 21.0004H15.8067C18.4581 21.0004 20.1004 19.5205 20.1004 16.8137V8.59984C20.1082 5.89399 18.4658 4.42188 15.8145 4.42188Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3771 12.3181L13.0008 13.5645C13.0631 13.6871 13.1808 13.7717 13.317 13.7912L14.7123 13.9916C14.939 14.0218 15.0976 14.229 15.0684 14.4557C15.0558 14.5482 15.012 14.6338 14.9448 14.699L13.9359 15.6681C13.8366 15.7624 13.7919 15.9006 13.8152 16.0349L14.0536 17.4038C14.0906 17.6325 13.9349 17.8475 13.7062 17.8845C13.6167 17.8991 13.5243 17.8835 13.4435 17.8407L12.1971 17.1947C12.0746 17.1314 11.9286 17.1314 11.806 17.1947L10.5587 17.8417C10.3543 17.9497 10.1004 17.8718 9.99238 17.6675C9.94957 17.5868 9.934 17.4943 9.9486 17.4048L10.188 16.0358C10.2113 15.9006 10.1665 15.7634 10.0673 15.6681L9.05735 14.699C8.89292 14.5404 8.88805 14.2796 9.04568 14.1152C9.11087 14.0471 9.19649 14.0043 9.28892 13.9916L10.6851 13.7912C10.8214 13.7727 10.9391 13.6871 11.0014 13.5645L11.626 12.3181C11.734 12.1109 11.9889 12.0301 12.1962 12.1371C12.274 12.177 12.3373 12.2403 12.3771 12.3181Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9742ca50b6a68ba9aef875d2e01469bf.svg";
export { ForwardRef as ReactComponent };